import { PRIMARY_COLOR } from '../../config/color';

export const SelectedArrow = () => (
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5 8.25L11 13.75L16.5 8.25" stroke="currentColor" stroke-width="1.5" />
  </svg>
);

export const LocationSVG = () => (
  <svg viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.6967 12.7839C2.33947 13.1911 1.5 13.7536 1.5 14.3749C1.5 15.6175 4.85786 16.6249 9 16.6249C13.1421 16.6249 16.5 15.6175 16.5 14.3749C16.5 13.7536 15.6605 13.1911 14.3033 12.7839"
      stroke="currentColor"
      stroke-width="1.125"
      stroke-linecap="square"
    />
    <path
      d="M9 13.625C9 13.625 13.875 10.439 13.875 6.75568C13.875 4.12919 11.6924 2 9 2C6.30761 2 4.125 4.12919 4.125 6.75568C4.125 10.439 9 13.625 9 13.625Z"
      stroke="currentColor"
      stroke-width="1.125"
    />
    <path
      d="M9 8.75C10.0355 8.75 10.875 7.91052 10.875 6.875C10.875 5.83948 10.0355 5 9 5C7.96448 5 7.125 5.83948 7.125 6.875C7.125 7.91052 7.96448 8.75 9 8.75Z"
      stroke="currentColor"
      stroke-width="1.125"
    />
  </svg>
);

export const CalenderSVG = () => (
  <svg viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.075 2.25H1.925C1.55221 2.25 1.25 2.54101 1.25 2.9V11.35C1.25 11.709 1.55221 12 1.925 12H14.075C14.4478 12 14.75 11.709 14.75 11.35V2.9C14.75 2.54101 14.4478 2.25 14.075 2.25Z"
      stroke="currentColor"
      stroke-width="1.13"
    />
    <path d="M4.25 0V2.25" stroke="currentColor" stroke-width="1.13" />
    <path d="M8.375 6H4.25" stroke="currentColor" stroke-width="1.13" />
    <path d="M11.75 9H4.25" stroke="currentColor" stroke-width="1.13" />
    <path d="M11.75 0V2.25" stroke="currentColor" stroke-width="1.13" />
  </svg>
);

export const VideoLogo = () => (
  <svg viewBox="0 0 150 84" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5" filter="url(#filter0_b_3634_6174)">
      <rect width="150" height="83.5714" rx="2" fill="#262626" />
    </g>
    <path
      d="M95.156 40.9465C95.7393 41.3446 95.7375 42.2054 95.1524 42.601L63.7465 63.8344C63.0816 64.284 62.1847 63.8065 62.1864 63.0038L62.278 20.402C62.2798 19.5994 63.1787 19.1257 63.8417 19.5781L95.156 40.9465Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_3634_6174"
        x="-4"
        y="-4"
        width="158"
        height="91.5713"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3634_6174" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_3634_6174"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const TrainingService01 = () => (
  <svg viewBox="0 0 53 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_2591_37989)">
      <rect y="0.5" width="53" height="53" fill="#EBE7F8" />
      <rect x="1" y="1.5" width="51" height="51" stroke="white" stroke-width="2" />
    </g>
    <path
      d="M11.917 13.875V40.125H30.8753V13.875H11.917Z"
      stroke="#3309CD"
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path d="M17.75 40.125V13.875" stroke="#3309CD" stroke-width="2.1875" stroke-linecap="square" />
    <path
      d="M41.0833 13.875H35.25V37.2083L38.1667 40.125L41.0833 37.2083V13.875Z"
      stroke="#3309CD"
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path d="M35.25 18.25H41.0833" stroke="#3309CD" stroke-width="2.1875" stroke-linecap="square" />
    <path
      d="M30.8753 13.875H11.917"
      stroke="#3309CD"
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M30.8753 40.125H11.917"
      stroke="#3309CD"
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M35.25 13.875V25.5417"
      stroke="#3309CD"
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M41.083 13.875V25.5417"
      stroke="#3309CD"
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <defs>
      <filter
        id="filter0_b_2591_37989"
        x="-55"
        y="-54.5"
        width="163"
        height="163"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="27.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_37989" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2591_37989"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const TrainingService02 = () => (
  <svg viewBox="0 0 74 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_2591_38002)">
      <rect y="37.2695" width="52" height="52" transform="rotate(-45 0 37.2695)" fill="#E4EFFF" />
      <rect
        x="1.41421"
        y="37.2695"
        width="50"
        height="50"
        transform="rotate(-45 1.41421 37.2695)"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M48.1663 34.4682V23.6458C48.1663 22.8404 47.5134 22.1875 46.708 22.1875H26.2913C25.4859 22.1875 24.833 22.8404 24.833 23.6458V49.8958C24.833 50.7013 25.4859 51.3542 26.2913 51.3542H37.958"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M29.208 31.6719H33.583"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M39.417 31.6719H43.792"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M29.208 39.6875H33.583"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M29.208 44.0625H33.583"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M31.3955 33.8594V29.4844"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M46.5098 46.7812L49.6034 49.8749"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <path
      d="M40.3224 46.7808C42.031 48.4893 44.8011 48.4893 46.5096 46.7808C48.2182 45.0722 48.2182 42.3021 46.5096 40.5936C44.8011 38.885 42.031 38.885 40.3224 40.5936C38.6139 42.3021 38.6139 45.0722 40.3224 46.7808Z"
      stroke={PRIMARY_COLOR}
      stroke-width="2.1875"
      stroke-linecap="square"
    />
    <defs>
      <filter
        id="filter0_b_2591_38002"
        x="-55"
        y="-54.5"
        width="183.539"
        height="183.539"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="27.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_38002" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2591_38002"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const TrainingService03 = () => (
  <svg viewBox="0 0 60 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_2591_38029)">
      <path
        d="M29.9406 0.5L44.6709 11.1646L59.3655 21.8785L53.7748 39.1834L48.1262 56.4696L29.9406 56.5L11.755 56.4696L6.10637 39.1834L0.515625 21.8785L15.2102 11.1646L29.9406 0.5Z"
        fill="#FFD9F2"
      />
      <path
        d="M15.7994 11.9727L29.9406 1.73457L44.0818 11.9727L44.0845 11.9746L58.1914 22.26L52.8242 38.8728L52.8232 38.876L47.4005 55.4708L29.9423 55.5H29.9389L12.4806 55.4708L7.05794 38.876L7.0569 38.8728L1.68977 22.26L15.7967 11.9746L15.7994 11.9727Z"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M34.1442 37.8333H26.8525V44.3958H34.1442V37.8333Z"
      stroke="#D642A6"
      stroke-width="2.19"
      stroke-linecap="square"
    />
    <path
      d="M42.8936 20.3333H18.1019C17.2965 20.3333 16.6436 20.9862 16.6436 21.7916V36.3749C16.6436 37.1803 17.2965 37.8333 18.1019 37.8333H42.8936C43.699 37.8333 44.3519 37.1803 44.3519 36.3749V21.7916C44.3519 20.9862 43.699 20.3333 42.8936 20.3333Z"
      stroke="#D642A6"
      stroke-width="2.19"
    />
    <path d="M29.04 34.1875H31.9567" stroke="#D642A6" stroke-width="2.19" stroke-linecap="square" />
    <path
      d="M23.2061 44.3958H37.7894"
      stroke="#D642A6"
      stroke-width="2.19"
      stroke-linecap="square"
    />
    <defs>
      <filter
        id="filter0_b_2591_38029"
        x="-54.4844"
        y="-54.5"
        width="168.85"
        height="166"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="27.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_38029" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2591_38029"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const TrainingService04 = () => (
  <svg viewBox="0 0 53 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_2591_38015)">
      <rect y="0.5" width="53" height="53" rx="26.5" fill="#FFE8B6" />
      <rect x="1" y="1.5" width="51" height="51" rx="25.5" stroke="white" stroke-width="2" />
    </g>
    <path
      d="M41.5029 40.9065H41.5529V40.8565V28.5V28.45H41.5029H39.9297H39.8797V28.5V40.8565V40.9065H39.9297H41.5029Z"
      fill="#FF7335"
      stroke="#FF7335"
      stroke-width="0.1"
    />
    <path
      d="M26.9531 40.8391L26.9281 40.9065H27H28.6552H28.69L28.7021 40.874L29.7552 38.0386H35.4542L36.5073 40.874L36.5194 40.9065H36.5542H38.2749H38.347L38.3218 40.839L33.7004 28.4825L33.6882 28.45H33.6535H31.5886H31.5539L31.5418 28.4826L26.9531 40.8391ZM34.8765 36.431H30.3166L32.6045 30.2505L34.8765 36.431Z"
      fill="#FF7335"
      stroke="#FF7335"
      stroke-width="0.1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9953 15.3182C12.9953 15.2351 13.0295 15.0881 13.2288 14.8787C13.4325 14.6646 13.7698 14.4309 14.2554 14.2151C15.2244 13.7844 16.6262 13.4951 18.2224 13.4951C19.8185 13.4951 21.2203 13.7844 22.1893 14.2151C22.675 14.4309 23.0123 14.6646 23.216 14.8787C23.4152 15.0881 23.4494 15.2351 23.4494 15.3182C23.4494 15.4013 23.4152 15.5483 23.216 15.7577C23.0123 15.9718 22.675 16.2055 22.1893 16.4213C21.2203 16.852 19.8185 17.1413 18.2224 17.1413C16.6262 17.1413 15.2244 16.852 14.2554 16.4213C13.7698 16.2055 13.4325 15.9718 13.2288 15.7577C13.0295 15.5483 12.9953 15.4013 12.9953 15.3182ZM18.2224 11.6951C16.4346 11.6951 14.7729 12.0153 13.5244 12.5702C12.9012 12.8472 12.3412 13.2003 11.9249 13.6378C11.504 14.08 11.1953 14.6494 11.1953 15.3182C11.1953 15.3311 11.1954 15.3439 11.1957 15.3567H11.1953V16.2567V19.2446V20.1446V24.4261C11.1953 25.0949 11.5041 25.6643 11.9249 26.1065C12.3412 26.544 12.9012 26.8971 13.5244 27.1741C14.7729 27.729 16.4346 28.0492 18.2224 28.0492C20.0101 28.0492 21.6718 27.729 22.9204 27.1741C23.5435 26.8971 24.1035 26.544 24.5199 26.1065C24.9407 25.6643 25.2494 25.0949 25.2494 24.4261V20.1446V19.2446V16.2567V15.3567H25.2491C25.2493 15.3439 25.2494 15.3311 25.2494 15.3182C25.2494 14.6494 24.9407 14.08 24.5199 13.6378C24.1035 13.2003 23.5435 12.8472 22.9204 12.5702C21.6718 12.0153 20.0101 11.6951 18.2224 11.6951ZM23.4494 17.8031C23.2798 17.8975 23.1028 17.9851 22.9204 18.0662C21.6718 18.6211 20.0101 18.9413 18.2224 18.9413C16.4346 18.9413 14.7729 18.6211 13.5244 18.0662C13.3419 17.9851 13.1649 17.8975 12.9953 17.8031V19.2446V20.1446C12.9953 20.2278 13.0295 20.3747 13.2288 20.5841C13.4325 20.7982 13.7698 21.0319 14.2554 21.2477C15.2244 21.6784 16.6262 21.9678 18.2224 21.9678C19.8185 21.9678 21.2203 21.6784 22.1893 21.2477C22.675 21.0319 23.0123 20.7982 23.216 20.5841C23.4152 20.3747 23.4494 20.2278 23.4494 20.1446V19.2446V17.8031ZM12.9953 24.4261V22.6296C13.1649 22.7239 13.3419 22.8115 13.5244 22.8926C14.7729 23.4475 16.4346 23.7678 18.2224 23.7678C20.0101 23.7678 21.6718 23.4475 22.9204 22.8926C23.1028 22.8115 23.2798 22.7239 23.4494 22.6296V24.4261C23.4494 24.5092 23.4152 24.6562 23.216 24.8656C23.0123 25.0796 22.675 25.3133 22.1893 25.5292C21.2203 25.9599 19.8185 26.2492 18.2224 26.2492C16.6262 26.2492 15.2244 25.9599 14.2554 25.5292C13.7698 25.3133 13.4325 25.0796 13.2288 24.8656C13.0295 24.6562 12.9953 24.5092 12.9953 24.4261Z"
      fill="#FF7335"
    />
    <path
      d="M32.333 13.875H36.708C38.3188 13.875 39.6247 15.1808 39.6247 16.7917V21.1667"
      stroke="#FF7335"
      stroke-width="2.19"
      stroke-linecap="square"
    />
    <path
      d="M20.6667 40.1249H16.2917C14.6808 40.1249 13.375 38.8191 13.375 37.2083V32.8333"
      stroke="#FF7335"
      stroke-width="2.19"
      stroke-linecap="square"
    />
    <defs>
      <filter
        id="filter0_b_2591_38015"
        x="-55"
        y="-54.5"
        width="163"
        height="163"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="27.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_38015" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_2591_38015"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const QuestionMark = () => (
  <svg viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.9997 20.6693C13.531 20.6693 15.8226 19.6432 17.4815 17.9844C19.1403 16.3256 20.1663 14.0339 20.1663 11.5026C20.1663 8.97132 19.1403 6.67965 17.4815 5.02079C15.8226 3.36195 13.531 2.33594 10.9997 2.33594C8.46839 2.33594 6.17672 3.36195 4.51786 5.02079C2.85902 6.67965 1.83301 8.97132 1.83301 11.5026C1.83301 14.0339 2.85902 16.3256 4.51786 17.9844C6.17672 19.6432 8.46839 20.6693 10.9997 20.6693Z"
      stroke="#0F5EF7"
      stroke-width="1.38"
    />
    <path
      d="M11 13.6224V11.7891C12.5188 11.7891 13.75 10.5578 13.75 9.03906C13.75 7.52028 12.5188 6.28906 11 6.28906C9.48122 6.28906 8.25 7.52028 8.25 9.03906"
      stroke="#0F5EF7"
      stroke-width="1.38"
      stroke-linecap="square"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0003 17.7448C11.6331 17.7448 12.1462 17.2318 12.1462 16.599C12.1462 15.9661 11.6331 15.4531 11.0003 15.4531C10.3675 15.4531 9.85449 15.9661 9.85449 16.599C9.85449 17.2318 10.3675 17.7448 11.0003 17.7448Z"
      fill="#0F5EF7"
    />
  </svg>
);

export const NoMatchedCourseSVG = () => (
  <svg
    width="305"
    height="297"
    viewBox="0 0 305 297"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34.5059"
      height="34.5059"
      transform="matrix(0.706544 -0.707669 0.706544 0.707669 32.4531 70.2865)"
      fill="#D9DEE3"
    />
    <rect
      width="21.9725"
      height="21.9725"
      transform="matrix(0.706544 -0.707669 0.706544 0.707669 59.1328 42.2683)"
      fill="#E4EFFF"
    />
    <rect
      width="11.6155"
      height="11.6155"
      transform="matrix(0.706544 -0.707669 0.706544 0.707669 86.25 54.0872)"
      fill="#E4EFFF"
    />
    <path
      d="M304.996 221.989L304.927 224.434L304.683 226.879L304.301 229.297L303.744 231.715L303.049 234.134L302.179 236.526L300.962 239.342L299.501 242.106L297.867 244.897L295.989 247.634L293.867 250.371L291.607 252.976L289.172 255.553L286.46 258.105L283.573 260.629L280.443 263.127L277.209 265.466L273.766 267.778L270.149 270.037L266.254 272.243L262.15 274.422L258.012 276.441L253.699 278.381L249.247 280.215L244.657 281.996L239.892 283.67L235.093 285.238L230.189 286.673L225.146 288.055L219.999 289.33L214.713 290.5L209.427 291.536L204.036 292.493L198.576 293.317L193.047 294.061L187.378 294.699L181.779 295.204L176.075 295.602L170.337 295.894L164.564 296.08L158.721 296.134L152.878 296.08L147.105 295.894L141.367 295.602L135.663 295.204L130.064 294.699L124.395 294.061L118.865 293.317L113.405 292.493L108.015 291.536L102.729 290.5L97.4423 289.33L92.2952 288.055L87.2524 286.673L82.3487 285.238L77.5494 283.67L72.7848 281.996L68.1942 280.215L63.7426 278.381L59.4302 276.441L55.2916 274.422L51.1878 272.243L47.2927 270.037L43.6758 267.778L40.2328 265.466L36.9985 263.127L33.8685 260.629L30.9819 258.105L28.2692 255.553L25.8348 252.976L23.5742 250.371L21.4528 247.634L19.5748 244.897L17.9402 242.106L16.4795 239.342L15.2623 236.526L14.3929 234.134L13.6973 231.715L13.1409 229.297L12.7583 226.879L12.5149 224.434L12.4453 221.989L12.5149 219.544L12.7583 217.099L13.1409 214.681L13.6973 212.262L14.3929 209.844L15.2623 207.452L16.4795 204.635L17.9402 201.871L19.5748 199.081L21.4528 196.344L23.5742 193.607L25.8348 191.002L28.2692 188.424L30.9819 185.873L33.8685 183.349L36.9985 180.85L40.2328 178.512L43.6758 176.2L47.2927 173.941L51.1878 171.735L55.2916 169.556L59.4302 167.536L63.7426 165.596L68.1942 163.763L72.7848 161.982L77.5494 160.308L82.3487 158.74L87.2524 157.305L92.2952 155.923L97.4423 154.647L102.729 153.478L108.015 152.442L113.405 151.485L118.865 150.661L124.395 149.917L130.064 149.279L135.663 148.774L141.367 148.376L147.105 148.083L152.878 147.897L158.721 147.844L164.564 147.897L170.337 148.083L176.075 148.376L181.779 148.774L187.378 149.279L193.047 149.917L198.576 150.661L204.036 151.485L209.427 152.442L214.713 153.478L219.999 154.647L225.146 155.923L230.189 157.305L235.093 158.74L239.892 160.308L244.657 161.982L249.247 163.763L253.699 165.596L258.012 167.536L262.15 169.556L266.254 171.735L270.149 173.941L273.766 176.2L277.209 178.512L280.443 180.85L283.573 183.349L286.46 185.873L289.172 188.424L291.607 191.002L293.867 193.607L295.989 196.344L297.867 199.081L299.501 201.871L300.962 204.635L302.179 207.452L303.049 209.844L303.744 212.262L304.301 214.681L304.683 217.099L304.927 219.544L304.996 221.989Z"
      fill="url(#paint0_radial_6843_21844)"
    />
    <path
      d="M158.895 65.0369L196.768 151.345L197.017 152.094L197.176 152.843L197.198 153.592L197.153 154.341L196.994 155.067L196.722 155.771L196.382 156.429L195.974 157.042L195.453 157.61L194.886 158.132L194.229 158.563L193.504 158.926L107.266 195.588L106.495 195.86L105.724 196.019L104.954 196.065L104.183 196.019L103.458 195.883L102.733 195.656L102.053 195.361L101.418 194.975L100.851 194.498L100.33 193.953L99.8995 193.341L99.5596 192.66L52.2814 81.1089L52.0321 80.3598L51.8735 79.6107L51.8281 78.8616L51.8961 78.1125L52.0548 77.386L52.3041 76.6823L52.644 76.024L53.0747 75.4111L53.596 74.8436L54.1626 74.3215L54.8198 73.8902L55.5451 73.527L118.008 46.9673L158.895 65.0369Z"
      fill="url(#paint1_linear_6843_21844)"
    />
    <path
      d="M134.626 165.078L132.337 166.032L132.087 166.077L131.77 165.941L131.475 165.714L130.863 164.942L130.41 163.852L130.297 163.353L130.32 162.49L130.456 162.195L130.637 162.036L132.926 161.06L133.175 161.038L133.493 161.151L133.787 161.378L134.399 162.173L134.898 163.353L135.034 164.284L134.966 164.67L134.807 164.919L134.626 165.078Z"
      fill="#CED7E2"
    />
    <path
      d="M126.188 168.642L108.351 176.247L108.011 176.292L107.626 176.224L107.263 176.02L106.878 175.68L106.56 175.271L106.288 174.749L106.107 174.181L106.039 173.682L106.062 173.183L106.152 172.774L106.356 172.433L106.651 172.229L124.511 164.647L124.851 164.579L125.236 164.67L125.599 164.874L125.961 165.192L126.55 166.145L126.777 166.781L126.845 167.326L126.822 167.757L126.686 168.166L126.482 168.461L126.188 168.642Z"
      fill="#DAE0EB"
    />
    <path
      d="M112.615 70.5077L71.6151 87.9418L70.9578 88.078L70.1192 87.8737L69.6659 87.6013L69.2806 87.1926L68.986 86.6932L68.8273 86.1484L68.8047 85.6036L68.918 85.0815L69.1447 84.6048L69.6206 84.1281L110.915 66.5124L111.573 66.3762L112.411 66.5805L112.864 66.8756L113.25 67.2615L113.544 67.761L113.703 68.3058L113.726 68.8733L113.612 69.3954L113.182 70.1218L112.615 70.5077Z"
      fill="#DAE0EB"
    />
    <path
      d="M130.068 115.014L89.0455 132.448L88.3883 132.562L87.5497 132.38L87.0964 132.085L86.7338 131.699L86.4391 131.2L86.2805 130.632L86.2578 130.087L86.3711 129.565L86.8018 128.816L87.3684 128.43L128.368 110.996L129.026 110.883L129.864 111.064L130.318 111.36L130.703 111.745L130.998 112.245L131.134 112.812L131.156 113.357L131.043 113.879L130.612 114.628L130.068 115.014Z"
      fill="#DAE0EB"
    />
    <path
      d="M92.5993 90.8248L75.6009 98.0208H74.8983L74.377 97.8846L73.9011 97.5895L73.5158 97.2036L73.2212 96.7042L73.0625 96.1594V95.5919L73.1985 95.0698L73.4251 94.5931L73.9238 94.0936L91.1034 86.7841H91.806L92.3273 86.9203L92.8033 87.2154L93.1886 87.6013L93.4832 88.1007L93.6419 88.6455V89.213L93.5286 89.7351L93.3246 90.1891L92.9846 90.5751L92.5993 90.8248Z"
      fill="#DAE0EB"
    />
    <path
      d="M112.513 137.516L95.4923 144.712H94.7897L94.2911 144.554L93.8152 144.281L93.4299 143.895L93.1352 143.396L92.9766 142.851V142.284L93.0899 141.761L93.3392 141.285L93.8378 140.785L111.018 133.476L111.72 133.453L112.241 133.612L112.695 133.907L113.103 134.293L113.375 134.792L113.533 135.337L113.556 135.882L113.443 136.427L113.216 136.881L112.899 137.267L112.513 137.516Z"
      fill="#DAE0EB"
    />
    <path
      d="M116.875 47.444L127.029 71.4158L127.459 72.2103L127.958 72.914L128.57 73.5496L129.25 74.0717L129.998 74.5257L130.814 74.8663L131.652 75.116L132.536 75.2522L133.42 75.2749L134.327 75.2068L135.211 75.0025L136.094 74.7074L157.966 65.4001"
      fill="url(#paint2_linear_6843_21844)"
    />
    <path
      d="M243.983 99.4058L223.97 191.502L223.721 192.274L223.404 192.977L222.996 193.59L222.52 194.158L221.953 194.657L221.341 195.066L220.684 195.406L219.981 195.656L219.233 195.815L218.463 195.883L217.67 195.86L216.876 195.724L125.606 174.613L124.813 174.386L124.111 174.068L123.453 173.659L122.841 173.16L122.32 172.615L121.889 172.025L121.504 171.367L121.232 170.686L121.028 169.959L120.938 169.21L120.96 168.484L121.073 167.712L148.294 49.6461L148.52 48.8743L148.838 48.1706L149.245 47.5577L149.744 46.9901L150.288 46.4907L150.9 46.0821L151.58 45.7416L152.283 45.4919L153.03 45.333L153.801 45.2649L154.572 45.2876L155.388 45.4238L221.5 60.724L243.983 99.4058Z"
      fill="url(#paint3_linear_6843_21844)"
    />
    <path
      d="M144.805 166.032L142.403 165.465L142.176 165.351L141.995 165.079L141.881 164.715L141.836 163.717L142.108 162.582L142.312 162.105L142.833 161.424L143.105 161.242H143.377L145.78 161.787L146.006 161.923L146.188 162.196L146.301 162.559L146.324 163.558L146.029 164.806L145.598 165.623L145.304 165.919L145.054 166.032H144.805Z"
      fill="#CED7E2"
    />
    <path
      d="M203.322 76.5916L159.919 66.558L159.307 66.2629L158.741 65.6046L158.537 65.1051L158.469 64.5603L158.514 63.9928L158.718 63.448L159.035 62.994L159.421 62.6308L159.874 62.3811L160.554 62.2676L204.296 72.3466L204.908 72.6417L205.475 73.2774L205.656 73.7768L205.747 74.3216L205.679 74.9118L205.498 75.4339L205.18 75.8879L204.772 76.2511L204.002 76.5916H203.322Z"
      fill="#DAE0EB"
    />
    <path
      d="M175.22 81.2453L157.225 77.0457L156.658 76.6371L156.341 76.2058L156.114 75.7063L156.023 75.1615L156.091 74.594L156.295 74.0492L156.613 73.5952L157.021 73.232L157.497 72.9823L158.199 72.8915L176.376 77.0911L176.943 77.4997L177.283 77.9083L177.487 78.4304L177.577 78.9752L177.532 79.5427L177.328 80.0876L177.011 80.5416L176.603 80.9048L176.15 81.1545L175.674 81.268L175.22 81.2453Z"
      fill="#DAE0EB"
    />
    <path
      d="M220.319 60.429L214.471 85.7855L214.335 86.6935L214.312 87.5788L214.448 88.4188L214.675 89.2587L215.038 90.0532L215.491 90.825L216.035 91.506L216.647 92.1416L217.372 92.6865L218.143 93.1632L218.959 93.5264L219.865 93.7988L243.006 99.1561"
      fill="url(#paint4_linear_6843_21844)"
    />
    <rect
      width="21.9725"
      height="21.9725"
      transform="matrix(0.706544 -0.707669 0.706544 0.707669 269.438 126.878)"
      fill="#E4EFFF"
    />
    <rect
      width="11.6155"
      height="11.6155"
      transform="matrix(0.706544 -0.707669 0.706544 0.707669 288.555 108.416)"
      fill="#E4EFFF"
    />
    <rect
      width="11.6155"
      height="11.6155"
      transform="matrix(0.706544 -0.707669 0.706544 0.707669 0 204.158)"
      fill="#E4EFFF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M182.93 113.753C178.699 113.116 174.716 116.065 174.068 120.386C173.885 121.602 172.753 122.44 171.539 122.257C170.325 122.074 169.488 120.94 169.671 119.724C170.678 113.007 176.896 108.341 183.591 109.349C190.286 110.356 194.86 116.646 193.853 123.363C192.958 129.327 187.957 133.673 182.161 133.869L181.562 137.863C181.379 139.079 180.247 139.917 179.033 139.734C177.819 139.552 176.983 138.418 177.165 137.202L178.064 131.206C178.247 129.99 179.379 129.152 180.593 129.335C184.825 129.972 188.808 127.022 189.456 122.702C190.104 118.381 187.162 114.389 182.93 113.753Z"
      fill="#D9DEE3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M178.128 147.254C179.342 147.437 180.179 148.571 179.996 149.787L179.732 151.548C179.55 152.764 178.417 153.602 177.203 153.419C175.989 153.237 175.153 152.103 175.335 150.887L175.599 149.125C175.782 147.909 176.914 147.071 178.128 147.254Z"
      fill="#D9DEE3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M199.512 158.931C200.709 158.071 202.376 158.347 203.234 159.546L221.847 185.555C222.705 186.754 222.43 188.423 221.233 189.283C220.036 190.143 218.369 189.867 217.511 188.668L198.898 162.659C198.039 161.46 198.314 159.791 199.512 158.931Z"
      fill="#D9DEE3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M144.357 125.756C147.952 105.501 167.261 92.001 187.483 95.6022C207.705 99.2034 221.184 118.542 217.589 138.797C213.993 159.051 194.685 172.552 174.463 168.95C154.24 165.349 140.761 146.01 144.357 125.756ZM186.549 100.863C169.228 97.7789 152.69 109.342 149.61 126.691C146.53 144.04 158.075 160.605 175.397 163.689C192.718 166.774 209.256 155.21 212.336 137.862C215.415 120.513 203.87 103.948 186.549 100.863Z"
      fill="#D9DEE3"
    />
    <defs>
      <radialGradient
        id="paint0_radial_6843_21844"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(158.721 151.504) scale(206.913 104.881)"
      >
        <stop stop-color="#BBC3CF" />
        <stop offset="1" stop-color="#FCFEFF" stop-opacity="0" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_6843_21844"
        x1="124.467"
        y1="43.5135"
        x2="124.467"
        y2="197.114"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="1" stop-color="#F3F5F8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6843_21844"
        x1="161.466"
        y1="72.4328"
        x2="128.903"
        y2="36.8585"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E7ECF1" />
        <stop offset="1" stop-color="#E5EAF1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6843_21844"
        x1="182.421"
        y1="41.7759"
        x2="182.421"
        y2="196.943"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="1" stop-color="#F3F5F8" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6843_21844"
        x1="245.45"
        y1="95.2014"
        x2="207.1"
        y2="74.1766"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E7ECF1" />
        <stop offset="1" stop-color="#E5EAF1" />
      </linearGradient>
    </defs>
  </svg>
);
